import React, { useEffect, useState } from 'react';
import { ArrowsClockwise } from '@phosphor-icons/react';
import { PageHeader, Surface, Button, Badge, Input, EmptyState } from '@/components/ui-kit';
import { api } from '@/lib/api';
import { useInstances } from '@/context/InstanceContext';
import { fmtDate, statusColor, shortJid } from '@/lib/utils';

export default function LogsPage() {
  const { current } = useInstances();
  const [logs, setLogs] = useState([]);
  const [statusFilter, setStatusFilter] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = { limit: 300 };
      if (current) params.instance = current;
      if (statusFilter) params.status = statusFilter;
      const list = await api.listLogs(params);
      setLogs(list);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLogs();
    const t = setInterval(fetchLogs, 6000);
    return () => clearInterval(t);
    // eslint-disable-next-line
  }, [current, statusFilter]);

  return (
    <div data-testid="page-logs">
      <PageHeader
        badge="// Auditoria"
        title="Histórico de envios"
        subtitle="Terminal-style log de todas as mensagens disparadas. Atualiza a cada 6s."
        actions={
          <>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="bg-zinc-900 border border-zinc-700 text-zinc-100 text-sm px-3 py-2 rounded-sm font-mono"
              data-testid="logs-status-filter"
            >
              <option value="">todos status</option>
              <option value="sent">enviados</option>
              <option value="failed">falhas</option>
            </select>
            <Button variant="secondary" onClick={fetchLogs}>
              <ArrowsClockwise size={14} className={loading ? 'animate-spin' : ''} />
              Atualizar
            </Button>
          </>
        }
      />

      {logs.length === 0 ? (
        <EmptyState title="Nenhum log ainda" hint="Dispare uma campanha para ver registros aqui." />
      ) : (
        <Surface className="p-4 font-mono text-xs">
          <ul className="space-y-1">
            {logs.map((l) => (
              <li key={l.id} className="grid grid-cols-12 gap-2 hover:bg-zinc-900/40 px-2 py-1.5 rounded-sm" data-testid={`log-row-${l.id}`}>
                <span className="col-span-2 text-zinc-400">{fmtDate(l.sentAt)}</span>
                <span className={`col-span-1 uppercase ${statusColor(l.status)}`}>
                  {l.status === 'sent' ? '●sent' : '✕fail'}
                </span>
                <span className="col-span-2 text-zinc-400">{l.type}</span>
                <span className="col-span-3 text-zinc-200 truncate">
                  {l.targetName || shortJid(l.targetJid)}
                </span>
                <span className="col-span-4 text-zinc-400 truncate">
                  {l.status === 'failed' ? (l.error || '').toString().slice(0, 120) : l.preview}
                </span>
              </li>
            ))}
          </ul>
        </Surface>
      )}
    </div>
  );
}
